import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

export default class extends Controller {
    connect() {
        MediaCenter.Modal.show();
        get(this.element.dataset['path'], { responseKind: 'turbo-stream' }).then(() => {
            setTimeout(() => MediaCenter.init(), 100);
            // rafactor -> remove the need of init
        })
    }
}
